
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, ArrowLeft, Mail } from "lucide-react";
import PageLayout from "@/layouts/PageLayout";

const PledgeError = () => {
  return (
    <PageLayout showBackButton={false}>
      <div className="min-h-screen bg-secondary/5 py-12 px-6">
        <div className="max-w-2xl mx-auto">
          <Card className="text-center">
            <CardHeader className="pb-6">
              <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <AlertCircle className="h-8 w-8 text-red-600" />
              </div>
              <CardTitle className="text-2xl text-red-700">
                Payment Not Completed
              </CardTitle>
              <p className="text-muted-foreground">
                Your pledge payment was not completed successfully.
              </p>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <h3 className="font-medium text-amber-900 mb-2">What can you do?</h3>
                <div className="space-y-2 text-sm text-amber-800">
                  <p>• Try pledging again - sometimes payment processors have temporary issues</p>
                  <p>• Check that your payment information is correct</p>
                  <p>• Contact your bank if the issue persists</p>
                  <p>• Reach out to our support team if you need assistance</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/#pledge-section" className="flex-1">
                  <Button variant="outline" className="w-full">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Try Again
                  </Button>
                </Link>
                <Link to="/" className="flex-1">
                  <Button className="w-full">
                    Return to Home
                  </Button>
                </Link>
              </div>

              <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
                <Mail className="h-4 w-4" />
                <span>Need help? Email us at support@cheqbooq.com</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
};

export default PledgeError;
